module.exports = __webpack_public_path__ + "media/images/img_no-5282f3321d0c65894272861dccceb1ec.png";